import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { GridComponent, GridSize, KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON, SVGIcon } from '@progress/kendo-angular-icons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { KENDO_NOTIFICATION } from '@progress/kendo-angular-notification';
import { SpreadsheetModule } from '@progress/kendo-angular-spreadsheet';
import { fileExcelIcon } from '@progress/kendo-svg-icons';
import { PortalLog, SearchLog,emptySearchLog } from '../../../../_models/admin';
import { PortalLogService } from '../../../../_services/portal-log.service';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { formatDateTime } from '../../../../globals';
import { ExcelExportEvent } from '@progress/kendo-angular-grid';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';


@Component({
    selector: 'app-portal-log',
    imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_NOTIFICATION,
        LayoutModule, CommonModule, DropDownListModule, InputsModule, LabelModule, FormsModule,
        ReactiveFormsModule, DialogsModule, SpreadsheetModule, DateInputsModule],
    templateUrl: './portal-log.component.html',
    styleUrl: './portal-log.component.css',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PortalLogComponent implements OnInit {
  excelSVG: SVGIcon = fileExcelIcon;
  pageSize: number = 30;
  public smallSize: GridSize = 'small';
  logsLoading: boolean = false;
  selection: any[] = [];
  portalLogs: PortalLog[] = [];
  displayLogs: PortalLog[] = [];
  private debounceTimer: any;

  //public search$ = new Subject<string>();
  public searchQuery: string = '';
  allLogs: PortalLog[] = [];
  
  startDate: Date | null = null;
  endDate: Date | null = null;
  minStartDate: Date;
  maxStartDate: Date;
  searchLog:SearchLog = emptySearchLog();



  @ViewChild('grid') grid!: GridComponent;

  constructor(private portalLogService: PortalLogService,
    private cdr: ChangeDetectorRef
  ) {

      const today = new Date();
      this.maxStartDate = today;

      const pastDate = new Date();
      pastDate.setMonth(today.getMonth() - 3);
      this.minStartDate = pastDate;

  }
  ngOnInit(): void {

    this.loadInitialData();

    /*this.search$.pipe(
      debounceTime(300), // wait for 300 ms pause in events  
      distinctUntilChanged() // ignore new value if same as previous value  
    ).subscribe(search => {
      if (search.length >= 3 || search === '') {
        this.getPortalLogs(search); // Call API only if search string is 3 or more characters  
      } else {
        // Clear logs if search is less than 3 characters  
        this.portalLogs = []; 
        this.displayLogs = []; 
      }
    });*/
  }

  loadInitialData() {
    // Call with empty string to load initial logs  
    this.searchLog = emptySearchLog();
    this.getPortalLogs(this.searchLog);
  }

  // performSearch() {
  //   this.getPortalLogs(this.searchQuery);
  // }

  onSearchInputChange() {
    // When the search input changes, check if it's empty  

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    console.log("this.searchQuery",this.searchQuery,this.searchLog.startDate,this.searchLog.endDate)
    // Set a new debounce timer
    this.debounceTimer = setTimeout(() => {
      if (this.searchQuery.trim() === '' &&  this.searchLog.startDate === null && this.searchLog.endDate === null) {
        this.loadInitialData();
      } else {

        
        const payload = {
          search: this.searchQuery,
          startDate: this.searchLog.startDate ? this.searchLog.startDate.toLocaleDateString('en-CA') : null,
          endDate: this.searchLog.endDate ? this.searchLog.endDate.toLocaleDateString('en-CA') : null
        };

        

        this.getPortalLogs(payload);
      }
    }, 500); // 500ms debounce delay

  }

  getPortalLogs(searchReqObj: any) {
    
    this.logsLoading = true;
    this.portalLogs = [];
    
    //searchReqObj.endDate = searchReqObj.endDate.toLocaleDateString('en-CA')
    this.portalLogService.getPortalLogs(searchReqObj).
      pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe({
        next: (result) => {
          this.portalLogs = result;
        },
        error: (error) => {
          console.log(error)
          this.logsLoading = false;
        },
        complete: () => {
          this.portalLogs?.forEach(item => {
            if (item.timestamp) {
              item.timestamp = formatDateTime(item.timestamp);
              item.description = this.formatDateInString(item.description);
            }
          })
          this.displayLogs = [...this.portalLogs];
          this.allLogs = [...this.portalLogs];
          this.cdr.markForCheck();
          this.logsLoading = false;
        }
      });
  }
  getFileName() {
    let str = 'Portal Log';
    return `${str} ${this.getFormattedDate()}.xlsx`
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  formatDateInString(inputString: string): string {
    const match = inputString.match(/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}Z?/);
    if (!match) return inputString;
    const formatted = formatDateTime(match[0]);
    return inputString.replace(match[0], formatted);
  }

  
  filterByDateRange(): void {

    this.onSearchInputChange();
    /*if (!this.startDate || !this.endDate) {
      this.displayLogs = [...this.allLogs]; // Reset to original logs
      return;
    }

    if (this.endDate < this.startDate) {
      alert("End date cannot be earlier than start date.");
      return;
    }

    this.displayLogs = this.allLogs.filter(log => {
      const logDate = new Date(log.timestamp);
      return logDate >= this.startDate! && logDate <= this.endDate!;
    });*/
  }



  onExcelExport(e: ExcelExportEvent): void {

    
    const headerRow = {
      cells: [
        { value: 'Logged User', background: '#808080', color: '#FFFFFF' },
        { value: 'Timestamp', background: '#808080', color: '#FFFFFF' },
        { value: 'Action', background: '#808080', color: '#FFFFFF' },
        { value: 'Object', background: '#808080', color: '#FFFFFF' },
        { value: 'Project Name', background: '#808080', color: '#FFFFFF' },
        { value: 'PO Name', background: '#808080', color: '#FFFFFF' },
        { value: 'User Name', background: '#808080', color: '#FFFFFF' },
        { value: 'Company Name', background: '#808080', color: '#FFFFFF' },
        { value: 'Description' , background: '#808080', color: '#FFFFFF'},
      ]
    };

    
    const dataRows = this.displayLogs.map(item => ({
      cells: [
        { value: item.loggedInUserName },
        { value: item.timestamp },
        { value: item.action },
        { value: item.object },
        { value: item.projectName },
        { value: item.portalObjectName },
        { value: item.userName },
        { value: item.companyName },
        { value: item.description },
      ]
    }));

    e.workbook.sheets[0].rows = [headerRow, ...dataRows];
  }

  resetFilters(){
    this.searchQuery = '';
    this.loadInitialData();

  }

}
